import * as homepageVideoActions from '../../action_creators/homepage/homepage_video_action_creators';
import HomepageVideoModel from '../../../models/homepage/homepage_video_module';
import log from '../../../services/logger_service';
import { setAB } from '../../../utils/ab_test_util';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(homepageVideoActions.homepageVideoLoading({}, store));

    const state = store.getState();
    const { abtest } = state.config;

    return HomepageVideoModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        const { data } = resp;
        Object.keys(data).forEach(key => {
          if (Array.isArray(data[key])) {
            setAB(data[key], abtest);
          }
        });

        dispatch(homepageVideoActions.homepageVideoLoaded(data, store));
      })
      .catch(function handleUserError(err) {
        dispatch(homepageVideoActions.homepageVideoLoadError(err, store));
        log.error(
          err,
          `Error in homepage video actions, message: ${err.message}`
        );
      });
  };
}
